import { createComponent } from '@carvana/merch-components';
import { useContext } from 'react';
import ShareContext from '~/context/common/ShareContext';
import GreenCheckIcon from '~/icons/GreenCheck';

export const Container = createComponent('div', {
  className: `
    fixed
    bottom-0
    left-0
    right-0
    top-0
    z-[1000]
    m-auto
    h-[88px]
    w-[282px]
    rounded
    bg-blue-6
    pb-[18px]
    pt-[18px]
    text-center
    text-lg
    font-bold
    text-white
  `
});

const ShareNotification = () => {
  const { isShareNotificationVisible } = useContext(ShareContext);

  return isShareNotificationVisible ? (
    <Container>
      <GreenCheckIcon />
      <p>Link copied to clipboard!</p>
    </Container>
  ) : null;
};

export default ShareNotification;
